import { Badge } from "@/components/ui/badge";
import { VehicleTest } from "@/types/vehicleTest";
import { carTestLabels } from "@/i18n/labels";
import { useLanguage } from "@/context/LanguageContext";

interface StatusBadgeProps {
  status: VehicleTest["status"];
  className?: string;
}

export const StatusBadge = ({ status, className = "" }: StatusBadgeProps) => {
  const { language } = useLanguage();
  const ct = carTestLabels(language);
  
  switch (status) {
    case "ongoing":
      return (
        <Badge className={`bg-yellow-600/20 text-yellow-600 hover:bg-yellow-600/30 ${className}`}>
          {ct.status.ongoing}
        </Badge>
      );
    case "approved":
      return (
        <Badge className={`bg-green-600/20 text-green-600 hover:bg-green-600/30 ${className}`}>
          {ct.status.approved}
        </Badge>
      );
    case "rejected":
      return (
        <Badge className={`bg-red-600/20 text-red-600 hover:bg-red-600/30 ${className}`}>
          {ct.status.rejected}
        </Badge>
      );
    case "created":
      return (
        <Badge className={`bg-blue-600/20 text-blue-600 hover:bg-blue-600/30 ${className}`}>
          {ct.status.created}
        </Badge>
      );
    case "active-listing":
      return (
        <Badge className={`bg-blue-600/20 text-blue-600 hover:bg-blue-600/30 ${className}`}>
          {ct.status.activeListing}
        </Badge>
      );
    case "complement":
      return (
        <Badge className={`bg-orange-500/20 text-orange-500 hover:bg-orange-500/30 ${className}`}>
          {ct.status.complement}
        </Badge>
      );
    case "pending-review":
      return (
        <Badge className={`bg-violet-600/20 text-violet-600 hover:bg-violet-600/30 ${className}`}>
          {ct.status.pendingReview}
        </Badge>
      );
    case "change-requested":
      return (
        <Badge className={`bg-amber-600/20 text-amber-600 hover:bg-amber-600/30 ${className}`}>
          {(ct.status as Record<string, string>)?.changeRequested ?? "Ändring begärd"}
        </Badge>
      );
    default:
      return null;
  }
};
